export default "__VITE_ASSET__HH1lUX0Cz8QM4YTIy1aNrA__"